import { StyleSheet, View } from 'react-native';
import { colors } from '@wre/infinity-question-store/theme/colors';

type ProgressBarProps = {
  /**
   * Progress given as a percentage, i.e. between 0 and 100 inclusive.
   * If `undefined`, this indicates the quiz hasn't been started yet. This is displayed differently from 0.
   */
  progress?: number;
  /** Default: fieryRose */
  color?: string;
};

/**
 * Progress bar to display given progress percentage
 */
export function ProgressBar({ progress, color }: ProgressBarProps) {
  return (
    <View style={styles.wrapper}>
      <View style={styles.totalBar}>
        {progress !== undefined && (
          <>
            <View
              style={[
                styles.progressBarFixedStart,
                // Set the color if we were given it
                color ? { backgroundColor: color } : undefined
              ]}
            />
            <View style={styles.progressBarVariableContainer}>
              <View
                style={[
                  styles.progressBar,
                  { width: `${progress}%` },
                  // Set the color if we were given it
                  color ? { backgroundColor: color } : undefined
                ]}
              />
            </View>
          </>
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    width: '100%'
  },
  totalBar: {
    backgroundColor: colors.greys200,
    width: '100%',
    height: 13,
    borderRadius: 21,
    overflow: 'hidden',
    flexDirection: 'row'
  },
  progressBarFixedStart: {
    width: 13,
    backgroundColor: colors.fieryRose
  },
  progressBarVariableContainer: {
    flex: 1,
    flexDirection: 'row'
  },
  progressBar: {
    backgroundColor: colors.fieryRose
  }
});
